module.exports = __webpack_public_path__ + "img/happy-hour-texto.a70c95d2.svg";